import { MakeOptionalExcept } from '@repo/types/utils';
import { infer as Infer, z } from 'zod';

import { postCreateSchema } from './postCreate.schema';
import { postRecipientsEditSchema } from './postRecipientsEdit.schema';

export const postEditSchema = postCreateSchema
  .extend({
    id: z.number(),
    memberChanges: z.array(postRecipientsEditSchema).optional(),
  })
  .omit({ groups: true });

export type PostEditSchema = Infer<typeof postEditSchema>;
export type PostEditSchemaEditPayload = MakeOptionalExcept<PostEditSchema, 'id'>;
